'use client';

import { AtSymbolIcon, KeyIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { signIn } from 'next-auth/react';
import GoogleLoginButton from "../components/GoogleLoginButton";
import { Button, Divider } from '@mui/material';
import { FormEvent, useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import Loader from './components/loader';

export default function LoginForm() {

  const [isLoading, setIsLoading] = useState(false);  
  const [errorMessage, setErrorMessage] = useState('');
  const searchParams = useSearchParams();
  const error = searchParams.get('error');

  useEffect(() => {
    if (error) {
      switch (error) {
        case 'CustomError:UserNotFound':
          setErrorMessage('O email associado a esta conta Google não está registado no nosso sistema.');
          break;
        case 'CustomError:DatabaseError':
          setErrorMessage('Ocorreu um problema com o nosso servidor. Por favor, tente novamente mais tarde.');
          break;
        case 'Configuration':
          setErrorMessage('Login ou senha inválidos.');
          break;
        case 'AccessDenied':
          setErrorMessage('Parece que seu email não está em nosso sistema.');
          break;
        default:
          setErrorMessage('Ocorreu um problema com o nosso servidor. Por favor, tente novamente mais tarde.');
          break;
      }
    }
  }, [error]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    const data = new FormData(event.currentTarget);

    const result = await signIn("credentials", {
      redirect: true,
      email: data.get('email'),
      password: data.get('password')
    });

    if (result?.error) {
      setErrorMessage("Credenciais inválidas.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      {isLoading && <Loader />}
      
      <div className="flex-1 rounded-lg px-6 pb-4 pt-8 sm:bg-white">

        <div className='flex justify-center '>
          <Image src="/Logo.png" width={150} height={30} alt="logo" className='hidden md:block' />
          <Image src="/Logo.png" width={250} height={30} alt="logo" className='md:hidden' />
        </div>

        {errorMessage && <div className="flex h-8 items-end space-x-1 justify-center">
          <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
          <p className="text-sm text-red-500">{errorMessage}</p>
        </div>}

        <div className="w-full">
          <div>
            <label className="mb-3 mt-5 block text-sm font-medium text-gray-900" htmlFor="email">
              Email
            </label>
            <div className="relative">
              <input className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500 w-full"
                id="email" type="email" name="email" placeholder="Coloque seu email" required />
              <AtSymbolIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
            </div>
          </div>
          <div className="my-4">
            <label className="mb-3 mt-5 block text-sm font-medium text-gray-900 dark:text-slate-50" htmlFor="password">
              Senha
            </label>
            <div className="relative">
              <input className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500 dark:text-slate-800"
                id="password" type="password" name="password" placeholder="Coloque sua senha" required minLength={6} />
              <KeyIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
            </div>
          </div>
        </div>

        <div className='w-full grid grid-rows gap-4'>
          <LoginButton />
          <Divider className='w-30' variant="middle" />
          {/*<GoogleLoginButton onClick={() => {setIsLoading(true); signIn("google");}} />*/}
        </div>


      </div>
    </form>
  );
}

function LoginButton() {
  return (
    <Button variant='contained' type='submit'>
      Entrar <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />
    </Button>
  );
}
